/* import __COLOCATED_TEMPLATE__ from './freshdesk.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type HandoffToExternalTicket from 'embercom/models/operator/visual-builder/step/handoff-to-external-ticket';
import { action } from '@ember/object';

interface FreshdeskHandoffData {
  requiresEmailVerification?: boolean;
}

interface Args {
  step: HandoffToExternalTicket;
  readOnly?: boolean;
}

export default class FreshdeskExternalTicketHandoffStepComponent extends Component<Args> {
  @service declare intl: IntlService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.initializeHandoffData();
  }

  get stepTitle() {
    return this.intl.t('operator.workflows.visual-builder.create-external-ticket.title', {
      integration: 'Freshdesk', // eslint-disable-line @intercom/intercom/no-bare-strings
      htmlSafe: true,
    });
  }

  @action
  handleEmailVerificationToggle() {
    this.handoffData.requiresEmailVerification = !this.handoffData.requiresEmailVerification;
    this.args.step.handoffData = { ...this.handoffData };
  }

  private initializeHandoffData() {
    let step = this.args.step as any;
    if (!step.handoffData) {
      step.handoffData = {};
    }
    if (step.handoffData.requiresEmailVerification === undefined) {
      step.handoffData.requiresEmailVerification = true;
    }
  }

  private get handoffData(): FreshdeskHandoffData {
    return this.args.step.handoffData as FreshdeskHandoffData;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::ExternalTicketHandoffSteps::Freshdesk': typeof FreshdeskExternalTicketHandoffStepComponent;
  }
}
